import { render } from "./Store.vue?vue&type=template&id=c86e4654&ts=true"
import script from "./Store.vue?vue&type=script&lang=ts"
export * from "./Store.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__